import axios from '@/lib/utils/_init/axios'
import '@/lib/utils/_init/appendPrototype'

function init(apiUrl: string): void {
  axios(apiUrl)
}

export default init
